import { RootState } from "@/redux/store";
import { useSelector, useDispatch } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { get_single_vendor } from "@/utils/vendorApi";
import { logoutVendor } from "@/redux/slices/vendorSlice";

const ProtectedVendor: React.FC = () => {
  const vendorState = useSelector((state: RootState) => state.vendor);
  const vendor = vendorState.vendor;
  const token = vendorState.token;
  const dispatch = useDispatch();

  const [isVerifying, setIsVerifying] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      if (!token) {
        setIsVerifying(false);
        return;
      }
      try {
        await get_single_vendor(token);
        setIsValid(true);
      } catch (error) {
        console.error("Token verification failed", error);
        dispatch(logoutVendor());
        setIsValid(false);
      } finally {
        setIsVerifying(false);
      }
    };

    verifyToken();
  }, [token, dispatch]);

  if (isVerifying) {
    return null; // Or a loading spinner if preferred
  }

  if (!token || !isValid) {
    return <Navigate to="/login-vendor" replace />;
  }

  // Check approval status
  if (vendor?.verificationStatus !== "Approved") {
    return <Navigate to="/pending-approval" replace />;
  }

  return <Outlet />;
};

export default ProtectedVendor;